export default "__VITE_ASSET__BF0vqeR7__"